import axios from 'axios';

//const url = 'http://localhost:5001/potlucks';
//const url = 'https://whatluck.herokuapp.com/potlucks';
//const url = 'https://careful-goat-pleat.cyclic.app/potlucks'
const url = 'https://what-luck-server.vercel.app/potlucks'

export const fetchPotlucks = () => axios.get(url);
export const createPotluck = (newPotluck) => axios.post(url, newPotluck)
export const updatePotluck = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost)
export const deletePotluck = (id) => axios.delete(`${url}/${id}`)

export const deleteReply = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost)